import { CheckCircle, Circle, DotsThreeVertical } from "@phosphor-icons/react";
import { JOB_STATUS_LABELS, JOB_STATUS_ORDER } from "@/lib/constants";

// Vertical timeline showing a valuation job from initiation to completion.
export default function JobTimeline({ status, statusHistory = [], compact = false }) {
  const currentIdx = JOB_STATUS_ORDER.indexOf(status);
  const histMap = {};
  (statusHistory || []).forEach((h) => { if (h?.status) histMap[h.status] = h.at; });

  return (
    <div className="relative" data-testid="job-timeline">
      {JOB_STATUS_ORDER.map((s, i) => {
        const done = i < currentIdx;
        const current = i === currentIdx;
        const at = histMap[s];
        return (
          <div key={s} className="flex gap-3 pb-5 last:pb-0 relative">
            {i < JOB_STATUS_ORDER.length - 1 && (
              <span className={`absolute left-[11px] top-6 bottom-0 w-0.5 ${done ? "bg-emerald-400" : "bg-border"}`} />
            )}
            <div className="relative z-10 shrink-0">
              {done ? <CheckCircle size={24} weight="fill" className="text-emerald-500" />
                : current ? <DotsThreeVertical size={24} weight="bold" className="text-accent bg-accent/15 rounded-full p-0.5" />
                : <Circle size={24} className="text-muted-foreground/40" />}
            </div>
            <div className="pt-0.5">
              <div className={`font-medium text-sm ${current ? "text-accent" : done ? "text-primary" : "text-muted-foreground"}`}>
                {JOB_STATUS_LABELS[s]}{current && <span className="ml-2 text-[10px] uppercase tracking-wide bg-accent/15 text-accent px-1.5 py-0.5 rounded">Current</span>}
              </div>
              {!compact && at && <div className="text-xs text-muted-foreground font-mono mt-0.5">{new Date(at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
